export default "__VITE_ASSET__vUOJwtBi__"